import * as THREE from "three";
import { BaseModify } from "../base/BaseModify";
import { Context } from "../core/context";
import { DBEntity, DbLine, DbMesh } from "@/CadEngine";
import {
  ModifyOperateState,
  DrawOperationMovePointBeforeParams,
  DrawOperationMovePointParams,
  IModifyOperation,
} from "./IModifyOperation";
import { FMathUtils } from "@/utils/FMathUtils";
import { ExtendHandleParameter, Linearity } from "@/core/Parameters";

class ExtendModify implements IModifyOperation {
  private onMouseMoveBind: ((e: PointerEvent) => void) | undefined;
  private onMouseUpBind: ((e: PointerEvent) => void) | undefined;
  private m_context: Context;
  private m_selects: DBEntity[] = [];
  private callbackData: (DbLine | DbMesh)[] = [];
  private m_selectLayerLineTypeName: Linearity | undefined;

  constructor(context: Context, handleData: ExtendHandleParameter) {
    this.m_context = context;
    this.updatedData(handleData);

    setTimeout(() => {
      this.m_context.ModifyManager.ModifyFinish(ModifyOperateState.complete);
    }, 200);
  }

  OnMovePointBefore(params: DrawOperationMovePointBeforeParams): void {}
  OnMovePoint(point: DrawOperationMovePointParams): void {}
  OnDownPoint(point: DrawOperationMovePointParams): void {}
  onKeyDown(e: KeyboardEvent): void {}
  onKeyUp(e: KeyboardEvent): void {}

  OnZoom(camera: THREE.Camera): void {}

  Finish(operate: ModifyOperateState) {
    return this.callbackData;
  }
  OnWheel(e: WheelEvent): void {}

  onMouseMove(e: PointerEvent): void {}
  onMouseDown(e: PointerEvent): void {}
  onMouseUp(e: PointerEvent): void {}
  updatedData(handleData: ExtendHandleParameter) {
    let { referData, transformDatas, isMerge } = handleData;
    if (referData && transformDatas.length) {
      for (let i = 0; i < transformDatas.length; i++) {
        let transformData = transformDatas[i];
        let transformDataLayerLineTypeName =
          this.m_context.ToolsManager.GetLayerLineTypeName(transformData);
        let result = FMathUtils.GetLineIntersection(referData, transformData);
        let start = new THREE.Vector3(
          transformData.points[0],
          transformData.points[1],
          transformData.points[2]
        );
        let end = new THREE.Vector3(
          transformData.points[transformData.points.length - 3],
          transformData.points[transformData.points.length - 2],
          transformData.points[transformData.points.length - 1]
        );
        if (result) {
          if (start.distanceTo(result) < end.distanceTo(result)) {
            transformData.points[0] = result.x;
            transformData.points[1] = result.y;
            transformData.points[2] = result.z;
          } else {
            transformData.points[transformData.points.length - 3] = result.x;
            transformData.points[transformData.points.length - 2] = result.y;
            transformData.points[transformData.points.length - 1] = result.z;
          }
        } else if (isMerge) {
          let refDataPoints = referData.points;
          let refDataStartPoint = new THREE.Vector3(
            refDataPoints[0],
            refDataPoints[1],
            refDataPoints[2]
          );
          let refDataEndPoint = new THREE.Vector3(
            refDataPoints[refDataPoints.length - 3],
            refDataPoints[refDataPoints.length - 2],
            refDataPoints[refDataPoints.length - 1]
          );
          let line3 = new THREE.Line3(refDataStartPoint, refDataEndPoint);
          let newStart = new THREE.Vector3();
          let newEnd = new THREE.Vector3();
          line3.closestPointToPoint(start, false, newStart);
          (transformData.points[0] = newStart.x),
            (transformData.points[1] = newStart.y),
            (transformData.points[2] = newStart.z);
          line3.closestPointToPoint(end, false, newEnd);
          (transformData.points[transformData.points.length - 3] = newEnd.x),
            (transformData.points[transformData.points.length - 2] = newEnd.y),
            (transformData.points[transformData.points.length - 1] = newEnd.z);
        }
        if (transformDataLayerLineTypeName == Linearity.Dash) {
          // 虚线
          let startPoint = new THREE.Vector3(
            transformData.points[0],
            transformData.points[1],
            transformData.points[2]
          );
          let endPoint = new THREE.Vector3(
            transformData.points[transformData.points.length - 3],
            transformData.points[transformData.points.length - 2],
            transformData.points[transformData.points.length - 1]
          );
          let breakPoints =
            this.m_context.ToolsManager.PassStartAndEndPointGetDashPoints(
              startPoint,
              endPoint
            );
          let index = 0;
          let indexes: number[] = [];
          let pointsArr = breakPoints.flatMap((point) => {
            indexes.push(index);
            index++;
            return [point.x, point.y, point.z];
          });
          transformData.points = new Float32Array(pointsArr);
          transformData.indexes = new Int32Array(indexes);
        }

        transformData.getBoundingBox();
        transformData.getBoundingSphere();
        this.callbackData.push(transformData);
      }
      this.m_context.ModelManager.ByDatasUpdateModel(transformDatas);
    }
  }
}

export { ExtendModify };
